export const STATES = [
  { label: 'Andhra Pradesh', value: 'Andhra Pradesh' },
  { label: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
  { label: 'Andaman & Nicobar Islands', value: 'Andaman & Nicobar Islands' },
  { label: 'Assam', value: 'Assam' },
  { label: 'Bihar', value: 'Bihar' },
  { label: 'Chandigarh', value: 'Chandigarh' },
  { label: 'Chhattisgarh', value: 'Chhattisgarh' },
  {
    label: 'Dadra and Nagar Haveli & Daman and Diu',
    value: 'Dadra and Nagar Haveli & Daman and Diu'
  },
  { label: 'Delhi', value: 'Delhi' },
  { label: 'Goa', value: 'Goa' },
  { label: 'Gujarat', value: 'Gujarat' },
  { label: 'Haryana', value: 'Haryana' },
  { label: 'Himachal Pradesh', value: 'Himachal Pradesh' },
  { label: 'Jammu and Kashmir', value: 'Jammu and Kashmir' },
  { label: 'Jharkhand', value: 'Jharkhand' },
  { label: 'Karnataka', value: 'Karnataka' },
  { label: 'Kerala', value: 'Kerala' },
  { label: 'Lakshadweep', value: 'Lakshadweep' },
  { label: 'Madhya Pradesh', value: 'Madhya Pradesh' },
  { label: 'Maharashtra', value: 'Maharashtra' },
  { label: 'Manipur', value: 'Manipur' },
  { label: 'Meghalaya', value: 'Meghalaya' },
  { label: 'Mizoram', value: 'Mizoram' },
  { label: 'Nagaland', value: 'Nagaland' },
  { label: 'Odisha', value: 'Odisha' },
  { label: 'Puducherry', value: 'Puducherry' },
  { label: 'Punjab', value: 'Punjab' },
  { label: 'Rajasthan', value: 'Rajasthan' },
  { label: 'Sikkim', value: 'Sikkim' },
  { label: 'Tamil Nadu', value: 'Tamil Nadu' },
  { label: 'Telangana', value: 'Telangana' },
  { label: 'Tripura', value: 'Tripura' },
  { label: 'Uttar Pradesh', value: 'Uttar Pradesh' },
  { label: 'Uttarakhand', value: 'Uttarakhand' },
  { label: 'West Bengal', value: 'West Bengal' }
];
export const GTV_TYPE = [
  { label: 'GTV: BPG', value: 'GTV: BPG' },
  { label: 'GTV: AGR', value: 'GTV: AGR' },
  { label: 'GTV: E-Bookings', value: 'GTV: E-Bookings' }
];
export const PARTENR_PRODUCT_LIST = {
  PG: {
    label: 'Payment Gateway',
    key: 'pg_configuration',
    value: 'PG'
  },
  LS: {
    label: 'Payment Link',
    key: 'ls_configuration',
    value: 'LS'
  },
  EDU: {
    label: 'Form & Feesbuzz',
    key: 'edu_configuration',
    value: 'EDU'
  },
  WIRE: {
    label: 'Wire',
    key: 'wire_configuration',
    value: 'WIRE'
  },
  INSTACOLLECT: {
    label: 'Instacollect',
    key: 'instacollect_configuration',
    value: 'INSTACOLLECT'
  }
};

export const BITLA_ID = 87692;
export const TESTING_ID = 4486;

export const TOUR_CUSTOM_REPORT_CONTENT = [
  {
    content: (
      <div>
        <h2>Welcome</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Generate New Report',
    content: 'Quickly generate a new report by clicking here',
    placement: 'left',
    target: '.generate-custom-report'
  },
  {
    title: 'Sectionwise Reports',
    content: 'Access detailed reports by navigating to the relevant sections',
    placement: 'right',
    target: '.ant-tabs-nav-list'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];
